// Gesture rows whose gesture was just chosen, per scenario form action. The rooms
// picker of such a row may only render after one or more refreshes (air/air waits
// for its dimensioning), so the row stays armed until its picker shows up and
// consumes it. Refreshes are Turbo visits that keep the form action, so the arm
// survives them, while another scenario's form never sees it.
const armedRowsByForm = new Map()

export function armRow (formAction, row) {
  if (!armedRowsByForm.has(formAction)) armedRowsByForm.set(formAction, new Set())
  armedRowsByForm.get(formAction).add(row)
}

export function opensAfterArm ({ formAction, fieldName, visible, selectable }) {
  const rows = armedRowsByForm.get(formAction)
  const row = rows && [...rows].find((armed) => fieldName.startsWith(`${armed}[`))
  if (!row) return false

  rows.delete(row)
  return visible && selectable
}
